import React from "react";

import EntryItem from "../../EntryItem";
import {
  IExamJog,
  jogInfoFields,
  createEmptyExamJog,
  EVetExamFields
} from "../../options";
import VetExamFormField from "../../VetExamFormField";
import { FormField } from "../../options";
import { checkSelectingFieldsOneEntry } from "../../helper";
import { useExamLockerContext } from "components/ExamLockerContext/ExamLockerContext";
import { useVetExamContext } from "components/VetExamOverlay/VetExamProvider/VetExamProvider";
import useStyles from "components/VetExamOverlay/styles";

interface IProps {
  jog: IExamJog;
  entryNumber: number;
}

const JogInformationEntry = (props: IProps) => {
  const { jog, entryNumber } = props;

  const classes = useStyles();
  const {
    values: { examJogs },
    setFieldValue
  } = useVetExamContext();
  const { lockExam } = useExamLockerContext();

  const handleDeleteHorseExamJog = async () => {
    const updatedJogs =
      examJogs.length === 1
        ? [createEmptyExamJog()]
        : examJogs.filter((item: IExamJog) => item.id !== jog.id);

    setFieldValue(EVetExamFields.EXAM_JOGS, updatedJogs);

    lockExam();
  };

  const renderField = (field: FormField) => {
    return <VetExamFormField key={field.key} field={field} entryState={jog} />;
  };

  const isDeleteButtonDisabled =
    entryNumber === 1 && !checkSelectingFieldsOneEntry(jog);

  return (
    <EntryItem
      entryNumber={entryNumber}
      onDeleteEntry={handleDeleteHorseExamJog}
      disabledRemoveButton={isDeleteButtonDisabled}
    >
      <div className={classes.fieldsWrapper}>
        {jogInfoFields.map(renderField)}
      </div>
    </EntryItem>
  );
};
export default JogInformationEntry;
